import { useCallback, useEffect, useState } from "react";
import Loading from "../loading/Loading";
import { Alert, Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import { getLibroProducts } from "../../controllers/products";
import { fetchStripeSessionSecret, submitMaterialOrder } from "../../controllers/orders";
import { stripeKey } from "../../controllers/config";
import { loadStripe } from "@stripe/stripe-js";
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from "@stripe/react-stripe-js";

function ComunidadOrdenarLibros({ comunidadId, matrimonioPresidente, matrimonioTesorero, type }) {
  const [libros, setLibros] = useState([]);
  const [cantidades, setCantidades] = useState({});
  const [presidentes, setPresidentes] = useState(matrimonioPresidente);
  const [tesoreros, setTesoreros] = useState(matrimonioTesorero);
  const [lineItems, setLineItems] = useState();
  const [session, setSession] = useState('');
  const [onPaymentComplete, setOnPaymentComplete] = useState(false);
  const [alert, setAlert] = useState();
  const [order, setOrder] = useState();
  const [orderRegistered, setOrderRegistered] = useState(false);
  const [paySelection, setPaySelection] = useState();
  const stripePromise = loadStripe(stripeKey);
  
  useEffect(() => {
    loadLibros();
    if (!presidentes && !tesoreros) {
      getTesoreroAndPresident();
    }
  }, []);
  useEffect(() => {
    console.log('session update:', session)
  }, [session]);
  useEffect(() => {
    if (onPaymentComplete) {
      submitOrder();
    }
  }, [onPaymentComplete]);

  async function loadLibros() {
    const l = await getLibroProducts();
    setLibros(l);
  }
  async function getTesoreroAndPresident() {}

  function updateCantidad(l, value) {
    console.log(l, value);
    let c = Object.assign({}, cantidades);
    if (!c[l.productId]) {
      c[l.productId] = {
        label: l.label,
        productType: l.productType,
        productId: l.productId,
        productPrice: l.costo,
        quantity: 0
      }
    }
    if(!value || isNaN(value)) {
      c[l.productId].quantity = 0;
    }
    else {
      c[l.productId].quantity = parseInt(value);
    }
    setCantidades(c);
  }

  function renderLibros() {
    return libros.map((l) => {
      // console.log('libro', cantidades, l.productId, cantidades[l.productId]?.cantidad);
      return <tr key={`product-row${l.productId}`}>
      <td>{l.label}</td>
      <td>${l.costo}</td>
      <td>
        <Form.Group className="mb-3" controlId={`cantidad-product-${l.productId}`}>
          <Form.Control name={`product--${l.productId}`} type="tel" placeholder="Cantidad" value={cantidades[l.productId]?.quantity || ''} onChange={(e) => updateCantidad(l, e.target.value)} />
        </Form.Group>
      </td>
      <td>${!isNaN(cantidades[l.productId]?.quantity) ? l.costo * cantidades[l.productId]?.quantity : 0}</td>
    </tr>
    })
  }

  function getLineItems() {
    const li = Object.values(cantidades).filter(c => c.quantity > 0);
    return li;
  }
  async function payLater(e) {
    e.preventDefault();
    const li = getLineItems();
    console.log('line items: ', li);
    if (li.length) {
      setLineItems(li);
      setPaySelection('payLater');
      try {
        let r = await submitMaterialOrder(`membership-${contacto.membership_id}-${Date.now()}`, '', li, contacto, false);
        setOrder(r.order);
        setOrderRegistered(true);
      }
      catch (e) {
        setAlert(<Alert variant="danger">Ocurrió un error al procesar la orden. Intente de nuevo más tarde.</Alert>);
      }
      
    }
  }

  let total = 0;
  Object.values(cantidades).forEach(c => {
    total += c.quantity * c.productPrice;
  });

  async function payNow(e) {
    e.preventDefault();
    const lineItems = Object.values(cantidades).filter(c => c.quantity > 0);
    console.log('line items: ', lineItems);
    if (lineItems.length) {
      setLineItems(lineItems);
      setPaySelection('payNow');
    }
  }

  const onStripePaymentComplete = useCallback(() => {
    setOnPaymentComplete(true);
  }, [session, lineItems, order]);

  let contacto = tesoreros || presidentes;

  const submitOrder = useCallback(async () => {
    let orderId = order?.order_id;
    await submitMaterialOrder(`membership-${contacto.membership_id}-${Date.now()}`, 'pago-por-stripe', lineItems, contacto, true, orderId);
    setOrderRegistered(true);
  }, [session, lineItems, order]);

  let mainContent;

  if (!contacto) {
    let apostolado;
    switch(type) {
      case 'region': apostolado = 'Matrimonio Coordinador de Región'; break;
      case 'diocesis': apostolado = 'Matrimonio Delegado Diocesano'; break;
      
      case 'comunidad':
      default:
          apostolado = 'Matrimonio Presidente o Tesorero de Comunidad';
    }
    return <Container>
      <Alert variant="warning">No se encontró {apostolado}.</Alert>
    </Container>
  }
  if (!libros) {
    return <Container><Loading /></Container>;
  }
  if (lineItems && paySelection === 'payNow') {
    const stripeOptions = {
      fetchClientSecret: fetchStripeSessionSecret(lineItems, null, setSession, contacto, setOrder),
      onComplete: onStripePaymentComplete,
    };
    mainContent = <div className="order-payment-wrapper">
      {order && !orderRegistered && <Alert variant="success">La órden se creó correctamente.<br/>Número de órden: {order.order_id}.<br/> Por favor realiza el pago.</Alert>}
      {onPaymentComplete && session && orderRegistered && <Alert variant="success">La orden se envió a los tesoreros nacionales con éxito.<br/>Número de orden: {order.order_id}</Alert>}
      <EmbeddedCheckoutProvider
        stripe={stripePromise}
        options={stripeOptions}
      >
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  }
  else if (lineItems && paySelection === 'payLater') {
    if (order) {
      mainContent = <Alert variant="success">La órden se creó correctamente.<br/>Número de órden: {order.order_id}.<br/> Por favor realiza el pago lo antes posible.</Alert>
    }
    else if (!alert) {
      mainContent = <Loading text="Estamos procesando tu orden. Espera en momento..." />
    }
  }
  else {
    mainContent = <>
      <Table>
          <thead>
            <tr>
              <td>Producto</td>
              <td>Costo</td>
              <td>Cantidad</td>
              <td>Monto</td>
            </tr>
          </thead>
          <tbody> 
            {renderLibros()}
            <tr>
              <td></td>
              <td></td>
              <td>Total</td>
              <td>${total}</td>
            </tr>
          </tbody>
        </Table>
        <Row className="mb-3 justify-content-md-end">
          <Col md={3}><Button key='submit-btn-1' type='button' variant='primary' onClick={payNow}>Ordenar y pagar</Button></Col>
          <Col md={3}><Button key='submit-btn-2' type='button' variant='secondary' onClick={payLater}>Ordenar y pagar después</Button></Col>
        </Row>
    </>
  }

  return <Container>
    <Form onSubmit={payNow}>
      <Row>
        <h2>Ordenar libros</h2>

        <p>Los libros se enviarán a la siguiente dirección:</p>
        <p>
          {contacto.label}<br />
          {contacto.user.profile.address_1} {contacto.user.profile.address_2}<br/>
          {contacto.user.profile.city}, {contacto.user.profile.state} {contacto.user.profile.zip_code}
        </p>
      </Row>
      <Row>{alert}</Row>
      <Row>
        {mainContent}
      </Row>
    </Form>
  </Container>;
}

export default ComunidadOrdenarLibros;